module.exports = __webpack_public_path__ + "img/punto-16.a923ebdb.png";